import React from 'react'
import './portfolio.css';
import IMG1 from '../../assets/portfolio1.jpeg';
import IMG2 from '../../assets/To-do-list.png';
import IMG3 from '../../assets/portfolio4.png';
import IMG4 from '../../assets/IMG4.jpg';
import IMG5 from '../../assets/IMG5.png';
import IMG6 from '../../assets/IMG6.png';
import {PiProjectorScreenChartLight} from 'react-icons/pi';

import { Tooltip } from '@mui/material';

const data = [
    {
        id: 1,
        image: IMG1,
        title: 'Music Player 🎹 - Music streming website!',
        github: 'https://github.com/awadhesh-kumar-verma/Music.github.io',
        demo: 'https://awadhesh-kumar-verma.github.io/Music.github.io/'
    },
    {
        id: 2,
        image: IMG2,
        title: 'To Do List',
        github: 'https://github.com/awadhesh-kumar-verma/To-di-list.github.io',
        demo: 'https://awadhesh-kumar-verma.github.io/To-di-list.github.io/'
    },
    {
        id: 3,
        image: IMG3,
        title: 'Gim centre!',
        github: 'https://github.com/awadhesh-kumar-verma/firstweb.github.io',
        demo: 'https://awadhesh-kumar-verma.github.io/firstweb.github.io'
    },
    
    {
        id: 4,
        image: IMG4,
        title: 'Complete React Application',
        github: 'https://github.com/awadhesh-kumar-verma/Complete-React-Project',
        demo: 'https://react-complete-app.netlify.app/'
    },
    {
        id: 5,
        image: IMG5,
        title: 'IERT Alumni',
        github: 'https://github.com/awadhesh-kumar-verma/alumnis',
        demo: 'https://ierts-alumni.netlify.app/'
    },
    {
        id: 6,
        image: IMG6,
        title: 'Play Drum',
        github: 'https://github.com/awadhesh-kumar-verma/play-drum',
        demo: 'https://awadhesh-kumar-verma.github.io/play-drum/'
    }
]

const Portfolio = () => {
    return (
        <section id='portfolio' >
            <h5>&nbsp;&nbsp;&nbsp;My recent Work</h5>
            <h2> <PiProjectorScreenChartLight/> Por<span className='port' >tfolio</span></h2>

            <div className='container portfolio__container' >
            {
                data.map(({id, image, title, github, demo}) => {
                    return (
                        <article key={id} className='portfolio__item' >
                            <div className='portfolio__item-image' >
                                <img src={image} alt={title} />
                            </div>
                            <h3> {title} </h3>
                            <div className='portfolio__item-cta' >
                                <Tooltip title="Github" >
                                    <a href={github} className='btn' target=''>Github</a>
                                </Tooltip>
                                <Tooltip title="Visit" >
                                    <a href={demo} className='btn btn-primary' target=''>Live Demo</a>
                                </Tooltip>
                            </div>
                        </article>
                    )
                })
            }
            </div>
        </section>
    );
};

export default Portfolio;